// Environment-based configuration using environment variables
export const brandName = process.env.REACT_APP_BRAND?.trim().toLowerCase();
export const businessunitName = process.env.REACT_APP_BUSINESS_UNIT_NAME;

export const environment = process.env.REACT_APP_ENV;

// Application version - can be set from environment or fallback to package.json version
export const appVersion = process.env.REACT_APP_VERSION || "1.0.10";

// Dynamic URL configuration based on environment
// Fix: Use REACT_APP_PYTHON_BASE_URL instead of REACT_APP_SIT_URL to avoid undefined URLs
export const pythonBaseUrl = process.env.REACT_APP_PYTHON_BASE_URL || process.env.REACT_APP_SIT_URL;
// .NET base URL
export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const AdminUrl = process.env.REACT_APP_ADMIN_URL;

// API Management URLs
export const SITURL = process.env.REACT_APP_SIT_URL;
export const UATPYTHON = process.env.REACT_APP_UAT_URL;
export const PREPRODURL = process.env.REACT_APP_PREPROD_URL;
export const PRODUCTIONURL = process.env.REACT_APP_PRODUCTION_URL;

// Feature flags and configuration
export const debugMode = process.env.REACT_APP_DEBUG_MODE === "true";
export const logLevel = process.env.REACT_APP_LOG_LEVEL;
export const enableAnalytics = process.env.REACT_APP_ENABLE_ANALYTICS === "true";
export const enableMockData = process.env.REACT_APP_ENABLE_MOCK_DATA === "true";

// Helper function to get current environment config
export const getCurrentEnvironmentConfig = () => {
  return {
    brandName,
    environment,
    businessunitName,
    pythonBaseUrl,
    BASE_URL,
    AdminUrl,
    debugMode,
    logLevel,
    enableAnalytics,
    enableMockData,
    appVersion,
  };
};

// Helper function to get the correct Python base URL for current environment
export const getPythonBaseUrl = () => {
  const env = process.env.REACT_APP_ENV;

  // Return the configured pythonBaseUrl if it's defined
  if (pythonBaseUrl && pythonBaseUrl !== "undefined") {
    return pythonBaseUrl;
  }

  // Fallback based on environment
  switch (env) {
    case "production":
      return (
        process.env.REACT_APP_PRODUCTION_URL ||
        "https://eus-rsg-ai-apim-dev.azure-api.net/api/prod/v1"
      );
    case "staging":
      return (
        process.env.REACT_APP_SIT_URL || "https://eus-rsg-ai-apim-dev.azure-api.net/api/dev/v1"
      );
    case "development":
    default:
      return (
        process.env.REACT_APP_LOCAL_PYTHON_BASE_URL ||
        "https://eus-rsg-ai-apim-dev.azure-api.net/api/dev/v1"
      );
  }
};

// Debug function to log current configuration
export const logCurrentConfig = () => {
  if (debugMode) {
    // console.log("Current Environment Config:", {
    //   environment,
    //   pythonBaseUrl: getPythonBaseUrl(),
    //   BASE_URL,
    //   debugMode,
    //   appVersion,
    // });
  }
};
